import {
    SAVE_PORTAL_REGISTRATION,
    SAVE_PORTAL_REGISTRATION_SUCCESS,
    PORTAL_REGISTRATION_ERROR,
    RESET_PORTAL_REGISTRATION_STATE,
  } from "./actionType";
  
  //  Save
  export const savePortalRegistration = (config = {}) => ({
    type: SAVE_PORTAL_REGISTRATION,
    config,
  });
  
  export const savePortalRegistrationSuccess = (resp) => ({
    type: SAVE_PORTAL_REGISTRATION_SUCCESS,
    payload: resp,
  });
  
  //  Error
  export const portalRegistrationError = () => ({
    type: PORTAL_REGISTRATION_ERROR,
  });

  // Reset
  export const resetPortalRegistrationState = () => ({
    type: RESET_PORTAL_REGISTRATION_STATE,
  });